import { Button } from '@talentmesh/ui/components/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@talentmesh/ui/components/dialog';
import UIStrings from '@/Utils/UIStrings';

interface ExitDialogProps {
    open: boolean;
    onCancel: () => void;
    onOk: () => void;
}

function ExitDialog({ onCancel, onOk, open }: ExitDialogProps) {
    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
            <DialogContent className="w-96 p-5">
                <DialogHeader>
                    <DialogTitle>{UIStrings.ExitWithUnsavedChanges}</DialogTitle>
                </DialogHeader>
                <DialogDescription>{UIStrings.ExitingNowWillDiscardAnyUnsavedChanges}</DialogDescription>
                <DialogFooter className="flex justify-center gap-2">
                    <Button variant="outline" onClick={onCancel}>
                        {UIStrings.ExitAndDiscard}
                    </Button>
                    <Button onClick={onOk}>{UIStrings.ContinueEditing}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default ExitDialog;
